// The list view's checkboxes (figures/_slivers and collections/_slivers): Select All / Select None and highlighting the
// chosen figures. (The bulk action buttons need no script: each sends the form to its own formaction.) A page can have
// several of these forms (e.g. one per group on a collection page), so everything here stays within its own form.
function markSelected(checkbox) {
  const sliver = checkbox.closest('.figure-sliver')
  if (sliver) sliver.classList.toggle('selected', checkbox.checked)
}

function selectAll(form, checked) {
  form.querySelectorAll('input.figure_checkbox').forEach((checkbox) => {
    checkbox.checked = checked
    checkbox.dispatchEvent(new Event('change', { bubbles: true }))
  })
  form.querySelectorAll('.select_all_figures').forEach((link) => { link.style.display = checked ? 'none' : '' })
  form.querySelectorAll('.select_none_figures').forEach((link) => { link.style.display = checked ? '' : 'none' })
}

document.addEventListener('click', (e) => {
  if (!e.target.closest) return
  const form = e.target.closest('form.figures_form')
  if (!form) return

  const selectLink = e.target.closest('.select_all_figures, .select_none_figures')
  if (!selectLink) return
  e.preventDefault()
  selectAll(form, selectLink.classList.contains('select_all_figures'))
})

document.addEventListener('change', (e) => {
  if (e.target.matches && e.target.matches('form.figures_form input.figure_checkbox')) markSelected(e.target)
})
